import { html } from "lit-html";

export const decoratorDefault = (Story) =>
    html`<div
        role="menu"
        style="display: flex; flex-direction: column; width: 280px; background: #f2f3f6;"
    >
        ${Story()}
    </div>`;

export const decoratorMenu = (Story) =>
    html`<div
        role="menu"
        style="display: flex; flex-direction: column; width: 280px; background: #f2f3f6; padding: 100px 0;"
    >
        ${Story()}
    </div>`;

export const getSubmenuSlot = (label: string, count: number = 3): string => {
    return Array(count)
        .fill("")
        .map(
            (_, index) =>
                `<ux-iws-sf-menu-item label="${label}.${index + 1}"></ux-iws-sf-menu-item>`
        )
        .join("\n");
};
